export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: "I'm not a physio — is this even my place?",
    a: "It exists precisely because you're not. The entire system is built on one rule: screen the situation, never diagnose the condition. It tells you what's yours to adapt — and when the professional move is referring out. It keeps you inside your scope; it never pushes you past it.",
  },
  {
    q: "I don't have time to read 300 pages.",
    a: 'You don\'t read it — you consult it. Volume 1 takes 15 minutes and works that same afternoon. Everything else is organized as "client says X → open page Y," designed for 90-second lookups on your phone.',
  },
  {
    q: "Another $27 PDF? I've bought things I never opened.",
    a: "Fair. That's exactly why Bonus #5 exists: a 7-day, 10-minutes-a-day implementation map — and why Volume 1 is built to be used in your very next class. Compare it to the real alternatives: injury workshops run $500–600 and end up as notes you never open in class. This is designed to be opened in the moment.",
  },
  {
    q: 'I already studied anatomy.',
    a: 'Anatomy tells you what a herniated disc is. This tells you what to do when she mentions it at 8:57. Knowledge and protocol are different products — this is the second one.',
  },
  {
    q: 'Mat or reformer?',
    a: 'Both. Every avoid / teach-instead protocol lists mat and reformer versions, including spring and setup notes.',
  },
  {
    q: 'Is this medical advice?',
    a: 'No — and that\'s the point. It\'s an educational reference for movement professionals: screening questions, red flags that always mean "refer out," and in-scope adaptations. It never diagnoses, and it\'s designed to complement — never replace — a client\'s healthcare team.',
  },
  {
    q: 'Is it for new or experienced instructors?',
    a: 'Both, differently. Newer instructors get the confidence system nobody taught them. Experienced instructors get consistency, word-for-word scripts, and the Professional Shield layer they\'ve been improvising for years.',
  },
  {
    q: "What if it's not for me?",
    a: '7-day guarantee. Full refund, keep the files.',
  },
];
